/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Empty_DescInputs */

const en_search_empty_desc = /** @type {(inputs: Search_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try adjusting your filters or search.`)
};

const es_search_empty_desc = /** @type {(inputs: Search_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intenta ajustar tus filtros o tu búsqueda.`)
};

const fr_search_empty_desc = /** @type {(inputs: Search_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayez d'ajuster vos filtres ou votre recherche.`)
};

const de_search_empty_desc = /** @type {(inputs: Search_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuche, deine Filter oder deine Suche anzupassen.`)
};

const ja_search_empty_desc = /** @type {(inputs: Search_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絞り込み条件や検索キーワードを変更してみてください。`)
};

const zh_search_empty_desc = /** @type {(inputs: Search_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请尝试调整您的筛选条件或搜索词。`)
};

const ar_search_empty_desc = /** @type {(inputs: Search_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حاول تعديل عوامل التصفية أو البحث.`)
};

const id_search_empty_desc = /** @type {(inputs: Search_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba sesuaikan filter atau pencarian Anda.`)
};

const it_search_empty_desc = /** @type {(inputs: Search_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova a modificare i filtri o la tua ricerca.`)
};

const ru_search_empty_desc = /** @type {(inputs: Search_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробуйте изменить фильтры или условия поиска.`)
};

const pt_search_empty_desc = /** @type {(inputs: Search_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tente ajustar seus filtros ou sua pesquisa.`)
};

const ko_search_empty_desc = /** @type {(inputs: Search_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`필터나 검색어를 조정해 보세요.`)
};

/**
* | output |
* | --- |
* | "Try adjusting your filters or search." |
*
* @param {Search_Empty_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_empty_desc = /** @type {((inputs?: Search_Empty_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Empty_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_empty_desc(inputs)
	if (locale === "es") return es_search_empty_desc(inputs)
	if (locale === "fr") return fr_search_empty_desc(inputs)
	if (locale === "de") return de_search_empty_desc(inputs)
	if (locale === "ja") return ja_search_empty_desc(inputs)
	if (locale === "zh") return zh_search_empty_desc(inputs)
	if (locale === "ar") return ar_search_empty_desc(inputs)
	if (locale === "id") return id_search_empty_desc(inputs)
	if (locale === "it") return it_search_empty_desc(inputs)
	if (locale === "ru") return ru_search_empty_desc(inputs)
	if (locale === "pt") return pt_search_empty_desc(inputs)
	return ko_search_empty_desc(inputs)
});